module.exports = __webpack_public_path__ + "static/img/3-e5f9c89c8f.e7f46d3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/3-e5f9c89c8f.jpg
// module id = k+KQ
// module chunks = 1